import { Box } from '@mui/material'
import { useStore } from '@priolo/jon'
import DateRangePickerH from 'components/controls/select/DateRangePickerH'
import { FunctionComponent, useMemo } from 'react'
import { BI_PRESETS } from "stores/bi/types"
import cycleSo from 'stores/cycle'
import querySo from 'stores/route/query'
import { URL_PAR } from 'stores/route/utils/types'
import { DateRange } from 'types/global'
import { dateRangeToUrl, urlToDateRange } from 'utils'
import SelectorBiPresetH from './SelectorBiPresetH'



const BiFilterHeader: FunctionComponent = () => {

	// STORE
	useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleChangeDateRange = (dateRange: DateRange) => {
		querySo.setSearchUrl([URL_PAR.PIVOT_DATE_RANGE, dateRangeToUrl(dateRange)])
	}
	const handlePresetChange = (preset: string) => {
		querySo.setSearchUrl([URL_PAR.PIVOT_PRESET, preset])
	}

	// RENDER
	const [dateRangeSel, preset, cycle] = useMemo(() => {
		const [dateRangeSelUrl, preset, cycleUuid] = querySo.getSearchUrl([URL_PAR.PIVOT_DATE_RANGE, URL_PAR.PIVOT_PRESET, URL_PAR.CYCLE_SEL])
		let dateRangeSel = urlToDateRange(dateRangeSelUrl)
		const cycle = cycleSo.getCycleByUuid(cycleUuid)
		return [dateRangeSel, preset as BI_PRESETS, cycle]
	}, [querySo.state.queryUrl])

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

			<DateRangePickerH
				dateRange={dateRangeSel}
				onChange={handleChangeDateRange}
			/>

			<SelectorBiPresetH
				preset={preset ?? BI_PRESETS.YIELD}
				onChange={handlePresetChange}
			/>

		</Box>
	)
}

export default BiFilterHeader

